import React, { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';

const caseDetails = {
    
    3: {
        id: 3,
        images: ['info-collegepur.png'],
        layout: 'grid3'
    },
    4: {
        id: 4,
        images: ['analytic-3.png','todo-1.png', 'analytic-2.png','todo-2.png',],
        layout: 'grid4'
    }
};

function CaseStudydetail() {
    const { id } = useParams();
    const [animate, setAnimate] = useState(false);
    // const caseDetail = caseDetails[id];

   useEffect(() => {
  // Redirect to Behance for cards 1 & 2
  if (id === "1") {
    window.location.href = "https://www.behance.net/gallery/228597219/StepVest-A-Invest-learning-plateform"
  } else if (id === "2") {
    window.location.href = "https://www.behance.net/gallery/225984345/MunchOn-A-snack-ordering-app-for-movie-theater"
  } else {
    setAnimate(true);
  }
}, [id]);
if (id === "1" || id === "2") {
    return null;
  }

  const caseDetail = caseDetails[id];

  if (!caseDetail) {
    return <p>Case detail not found</p>;
  }
    return (
        <section className={`case-detail-page ${animate ? 'slide-in' : ''}`}>
            <div className="case-detail-main">
                <div className="deatilpages">
                    <Link to='/case-study' className='detail-close-icon'><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 384 512"><path d="M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z" /></svg></Link>
                    <div className={`details ${caseDetail.layout}`}>
                        {/* Show <p> tag at the top for ID 1 & 2 */}
                        {(caseDetail.id === 1 || caseDetail.id === 2 || caseDetail.id === 4) && (
                            <p className="prototype-link">
                                <a
                                    href={
                                        caseDetail.id === 1
                                            ? "https://www.figma.com/proto/MqybucmvxzeZODMeG5HI3R/New-assignment-of-college-practice?node-id=1-12639&t=uuYFbgaIH4xi4VjV-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=1%3A12639"
                                            : caseDetail.id === 4
                                                ? "https://www.figma.com/proto/Ba83nlUlJRCfIwQEDgt2y5/To-Do-list-case-Study?node-id=11-24&t=Th8ANTDrmguV26zF-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=11%3A24" 
                                                : "https://www.figma.com/proto/EPp21udzQSEU9Rm36okR1B/sign-up-module?node-id=10-51&t=RDhO4YBVfJCkP4AR-1&scaling=scale-down&content-scaling=fixed&page-id=0%3A1&starting-point-node-id=10%3A51"
                                    }
                                    target="_blank"
                                    rel="noopener noreferrer"
                                >

                                    <span className='figma-link'>View Prototype:{" "}: Open in Figma</span>
                                </a>
                            </p>
                        )}

                        {/* Image Grid */}
                        {caseDetail.images.map((image, index) => (
                            <div className="detail-img" key={index}>
                                <img src={require(`../../images/${image}`)} alt="" />
                            </div>
                        ))}
                    </div>

                </div>
            </div>
        </section>
    );
}

export default CaseStudydetail;
